const statusIcon = {
  bindings: {
    versionStatus: '<',
    upgradeFlag: '<'
  },
  templateUrl:
    '/modules/configurationManagement/train-management/status-icon/status-icon.html',
  controller: 'StatusIconController',
};

angular
  .module('configuration-management.module')
  .component('statusIcon', statusIcon);
